// 手机号校验（中国大陆手机号，支持1开头11位，或299开头10位）
export function isValidPhone(phone) {
  return /^1\d{10}$|^299\d{8}$/.test(phone)
}

// 邮箱校验
export function isValidEmail(email) {
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)
} 